import React from 'react';
import { Input } from 'antd';

import { Label } from 'components';

const { TextArea } = Input;

const TextAreaField = ({ label, asterisk, bold, rows, ...rest }) => {
  return (
    <>
      <Label label={label}  bold={bold} asterisk={asterisk}/>
      <TextArea {...rest} rows={rows || 6} />
    </>
  );
};

export default TextAreaField;
